import { render, staticRenderFns } from "./LpuFilters.vue?vue&type=template&id=4f8bb43f&"
import script from "./LpuFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8bb43f')) {
      api.createRecord('4f8bb43f', component.options)
    } else {
      api.reload('4f8bb43f', component.options)
    }
    module.hot.accept("./LpuFilters.vue?vue&type=template&id=4f8bb43f&", function () {
      api.rerender('4f8bb43f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuFilters/LpuFilters.vue"
export default component.exports